import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "section-header bold" }
const _hoisted_2 = {
  key: 0,
  class: "address-container"
}
const _hoisted_3 = {
  key: 1,
  class: "address-container"
}
const _hoisted_4 = { class: "address-editor" }
const _hoisted_5 = {
  class: "address-content",
  "data-cy": "address-content"
}
const _hoisted_6 = {
  key: 0,
  class: "address-issues"
}
const _hoisted_7 = {
  key: 0,
  class: "has-issue"
}
const _hoisted_8 = {
  key: 1,
  class: "has-issue"
}
const _hoisted_9 = {
  key: 2,
  class: "has-issue"
}
const _hoisted_10 = {
  key: 3,
  class: "has-issue"
}
const _hoisted_11 = {
  key: 4,
  class: "has-issue"
}
const _hoisted_12 = {
  class: "address-field--label subdue",
  "data-cy": "address-field-label"
}
const _hoisted_13 = { class: "address-field--value" }
const _hoisted_14 = { class: "address-field--value" }
const _hoisted_15 = { class: "address-field--value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ozn_button = _resolveComponent("ozn-button")!
  const _component_form_input = _resolveComponent("form-input")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["order-address-data order-address-data--container", {wideview: _ctx.itemView === 3 || _ctx.itemView === 1}]),
    "data-cy": "address-data-container"
  }, [
    _createElementVNode("h6", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("b", null, "Delivery information", -1)),
      (!_ctx.readonly && !_ctx.editing)
        ? (_openBlock(), _createBlock(_component_ozn_button, {
            key: 0,
            class: "minimal inline-action order-address-data--toggle-edit",
            label: "Edit",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editing = true)),
            "data-cy": "toggle-address-data"
          }))
        : _createCommentVNode("", true),
      (_ctx.editing)
        ? (_openBlock(), _createBlock(_component_ozn_button, {
            key: 1,
            class: "inline-action",
            label: "Save",
            onClick: _ctx.save
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.editing)
        ? (_openBlock(), _createBlock(_component_ozn_button, {
            key: 2,
            class: "inline-action",
            label: "Cancel",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editing=false))
          }))
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "content", {}, () => [
      (!_ctx.payload && !_ctx.editing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "meta" }, "No address data", -1)),
            _createElementVNode("u", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editing = true))
            }, "Add data to continue")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _withDirectives(_createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.parsedAddress), (field, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "address-field",
                  key: `address-field-${field}-${i}-${_ctx.id}`
                }, [
                  _createVNode(_component_form_input, {
                    class: "small",
                    modelValue: _ctx.parsedAddress[field],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.parsedAddress[field]) = $event),
                    id: `address-field-${field}-${i}-${_ctx.id}`,
                    type: typeof _ctx.parsedAddress[field] === 'number' ? 'tel' : 'text',
                    label: _ctx.AddressDisplayName[field] || field,
                    "input-class": "small"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "type", "label"])
                ]))
              }), 128))
            ], 512), [
              [_vShow, _ctx.editing]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              (_ctx.showIssues)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (!_ctx.parsedAddress.street)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Address is missing a street name!"))
                      : _createCommentVNode("", true),
                    (!_ctx.parsedAddress.street_number)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Address is missing a street number!"))
                      : _createCommentVNode("", true),
                    (!_ctx.parsedAddress.zipcode)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Address is missing a zipcode!"))
                      : _createCommentVNode("", true),
                    (!_ctx.parsedAddress.city)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Address is missing a city!"))
                      : _createCommentVNode("", true),
                    (!_ctx.parsedAddress.country_iso && !_ctx.countryNameToISO(_ctx.parsedAddress.country))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Address is missing a country (ISO-code)!"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.parsedAddress.fullname ? _ctx.parsedAddress.fullname : `${_ctx.parsedAddress.firstname || ''} ${_ctx.parsedAddress.lastname || ''}`), 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.parsedAddress.street) + " " + _toDisplayString(_ctx.parsedAddress.street_number) + _toDisplayString(_ctx.parsedAddress.addition), 1),
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.parsedAddress.zipcode) + _toDisplayString(_ctx.parsedAddress.zipcode || _ctx.parsedAddress.city ? ',' : '') + " " + _toDisplayString(_ctx.parsedAddress.city), 1),
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.parsedAddress.country) + " " + _toDisplayString(`(${_ctx.parsedAddress.country_iso || _ctx.countryNameToISO(_ctx.parsedAddress.country) || ''})`), 1)
            ], 512), [
              [_vShow, !_ctx.editing && _ctx.payload]
            ])
          ]))
    ], true)
  ], 2))
}